import { Injectable } from "@angular/core";
import { AuthService } from "./auth.service";
import { firstValueFrom } from "rxjs";

interface RoleInfo {
    IS_ACTIONABLE: string | null,
    IS_HYBRID_OPERATE: string | null,
    PROGRAM_LIST: string | null,
    UR_MO: string | null,
    UR_MOS: string | null,
    UR_OSolution: string | null,
    UR_ROLE: string | null
}

@Injectable({
    providedIn: 'root',
})
export class RoleService {
    getRoleName() {
        return this.roles.length > 0 ? this.roles[1].UR_ROLE : '';
    }
    roles: RoleInfo[] = [];
    constructor(private authService: AuthService) {
        firstValueFrom(this.authService.fetchAndCacheRoles()).then(res => {
            this.roles = res.roleInfo;
        });
    }

    isAdmin() {
        return this.roles.some(role => role.UR_ROLE === 'QRM Admin');
    }
    isInRole(roleName: string) {
        return this.roles.some(role => role.UR_ROLE === roleName);
    }

    hasRoles(roleNames: string[]): boolean {
        return roleNames.every(roleName => this.roles.some(role => role.UR_ROLE === roleName));
    }
}
